import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const mockHistory = [
  {
    version: "196.0",
    modifiedDate: "9/26/2025 7:17 PM",
    modifiedBy: "Alejandro Caliz",
    changes: [
      { field: "Writeback Date", oldValue: "9/1/2025", newValue: "9/5/2025" },
      { field: "VAR (wk) - Approved SS vs IO", oldValue: "0.00", newValue: "0.50" }
    ]
  },
  {
    version: "195.0",
    modifiedDate: "9/15/2025 12:26 AM",
    modifiedBy: "Jonathan Quintana",
    changes: [
      { field: "NewLine", oldValue: "Exists", newValue: "Sent" }
    ]
  }
];

export default function VersionHistoryDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        Version History
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ background: "#fafafa" }}>
        {mockHistory.map((item, index) => (
          <Box key={index} sx={{ display: "flex", mb: 4 }}>
            
            {/* TIMELINE COLUMN */}
            <Box sx={{ mr: 3, position: "relative" }}>
              {/* Timeline Dot */}
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  background: "#1976d2",
                  borderRadius: "50%",
                  position: "absolute",
                  left: -7,
                  top: 5
                }}
              />

              {/* Line */}
              {index !== mockHistory.length - 1 && (
                <Box
                  sx={{
                    width: 2,
                    background: "#c7c7c7",
                    height: "100%",
                    position: "absolute",
                    left: -1,
                    top: 22
                  }}
                ></Box>
              )}
            </Box>

            {/* MAIN CONTENT BOX */}
            <Box
              sx={{
                background: "white",
                p: 2,
                borderRadius: 2,
                flex: 1,
                boxShadow: "0px 1px 4px rgba(0,0,0,0.15)"
              }}
            >
              {/* TOP ROW: LEFT = Version + Date | RIGHT = Modified By */}
              <Box sx={{ display: "flex", justifyContent: "" }}>
                <Box>
                <Typography variant="subtitle2" fontWeight={600}>
                  Modified By: {item.modifiedBy}
                </Typography>
                  <Typography variant="subtitle2" fontWeight={700}>
                    Version {item.version}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Modified on {item.modifiedDate}
                  </Typography>
                </Box>

               
              </Box>

              <Divider sx={{ my: 1 }} />

              {/* CHANGES LIST */}
              {item.changes.map((c, idx) => (
                <Box key={idx} sx={{ mb: 1 }}>
                  <Typography variant="body2">
                    <strong>{c.field}</strong>
                  </Typography>
                  <Typography variant="caption">
                    Old: {c.oldValue}
                  </Typography>
                  <br />
                  <Typography variant="caption">
                    New: {c.newValue}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
}
